import React, { useEffect, useState } from "react";
import UserManagement from "./UserManagement";
import SamplePage from "./SamplePage";
import StudentPage from "./StudentPage";
import Status from "./Status";
import Display from "./Display";
import DemoClass from "./DemoClass";
import { useParams } from "react-router-dom";
import axios from "axios";
import EnrollmentsList from "./EnrollmentsList";
import SessionsList from "./SessionsList";
import { StudentDashboard } from "./StudentDashboard";
import UpcomingClassesSidebar from "./UpcomingClassesSidebar";
import StudentTab from "./StudentTab";
import EnrollmentsListTutor from "./EnrollmentsListTutor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UpcomingClassesSidebarTutor from "./UpcomingClassesSidebarTutor";
import GeneralMessages from "./GeneralMessages";
import DisplayDocuments from "./DisplayDocuments";
import SessionsList2Tutor from "./SessionsList2Tutor";


const SideBarMenuTutor = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [flagged, setFlagged] = useState(false);
  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/products`);
        const filteredProducts = res.data.filter(
          (user) => user.id === parseInt(id) && user.role === "tutor"
        );
        setProducts(filteredProducts);
        setLoading(false);
        setTimeout(() => {
          console.log("Executed after 3 seconds");
        }, 3000);
      } catch (err) {
        console.error("Error fetching files", err);
      }
    };

    fetchFiles();
  }, []);

  // Sample data for the student dashboard
  const [upcomingClasses] = useState([
    {
      id: 1,
      title: "Calculus 101",
      topic: "Integration Techniques",
      tutor: "Dr. Sarah Johnson",
      time: "Today, 2:00 PM",
      duration: "60 mins",
      meetingLink: "#",
    },
    {
      id: 2,
      title: "Physics Advanced",
      topic: "Quantum Mechanics",
      tutor: "Prof. Michael Chen",
      time: "Tomorrow, 11:00 AM",
      duration: "90 mins",
      meetingLink: "#",
    },
  ]);

  const [enrolledCourses] = useState([
    {
      id: 1,
      title: "Calculus 101",
      progress: 65,
      nextLesson: "Integration Techniques",
      tutor: "Dr. Sarah Johnson",
      grade: "A-",
    },
    {
      id: 2,
      title: "Physics Advanced",
      progress: 42,
      nextLesson: "Quantum Mechanics",
      tutor: "Prof. Michael Chen",
      grade: "B+",
    },
    {
      id: 3,
      title: "Literature Survey",
      progress: 88,
      nextLesson: "Modern Poetry",
      tutor: "Dr. Emma Williams",
      grade: "A",
    },
  ]);

  const [performanceStats] = useState([
    {
      title: "Completed Courses",
      value: "12",
      icon: "fas fa-trophy",
      trend: "↗︎ 3 this semester",
    },
    {
      title: "Average Grade",
      value: "B+",
      icon: "fas fa-star",
      trend: "↗︎ Improved from B",
    },
    {
      title: "Study Hours",
      value: "86",
      icon: "fas fa-clock",
      trend: "↗︎ 12% from last month",
    },
  ]);

  const [recommendedCourses] = useState([
    {
      id: 1,
      title: "Organic Chemistry",
      description: "Explore carbon compounds and reactions",
      category: "Science",
      level: "Intermediate",
      rating: 4.7,
      students: 124,
    },
    {
      id: 2,
      title: "World History",
      description: "From ancient civilizations to modern era",
      category: "Humanities",
      level: "Beginner",
      rating: 4.5,
      students: 89,
    },
    {
      id: 3,
      title: "Programming Fundamentals",
      description: "Learn Python from scratch",
      category: "Computer Science",
      level: "Beginner",
      rating: 4.8,
      students: 215,
    },
  ]);

  const [recentAssignments] = useState([
    {
      id: 1,
      title: "Calculus Problem Set 5",
      course: "Calculus 101",
      dueDate: "Tomorrow, 11:59 PM",
      status: "pending",
      priority: "high",
    },
    {
      id: 2,
      title: "Physics Lab Report",
      course: "Physics Advanced",
      dueDate: "In 3 days",
      status: "pending",
      priority: "medium",
    },
    {
      id: 3,
      title: "Essay on Modernism",
      course: "Literature Survey",
      dueDate: "Submitted",
      status: "completed",
      grade: "A-",
    },
  ]);

  return (
    <>
   <h1 className="text-2xl font-bold bg-primary"></h1>
    <div className="flex flex-col min-h-screen bg-base-100">
      {/* Mobile Header with Hamburger Menu */}
      <div className="navbar bg-base-200 lg:hidden">
        <div className="flex-none">
          <button
            className="btn btn-square btn-ghost"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="inline-block w-5 h-5 stroke-current"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>
        <div className="flex-1">
          <a className="btn btn-ghost normal-case text-xl">Tutor Portal</a>
        </div>
      </div>

      {/* Main Content */}

      <div className="flex flex-1">
        {/* Sidebar - Hidden on mobile unless opened */}
        <div
          className={`
            w-64 bg-base-200 transition-all duration-300 ease-in-out
            fixed lg:relative inset-y-0 left-0 z-30 lg:z-auto
            transform ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
            lg:translate-x-0 h-screen lg:h-auto overflow-y-auto
          `}
        >
          <div className="p-4">
            {/* Close button for mobile */}
            <div className="flex justify-end lg:hidden">
              <button
                className="btn btn-sm btn-circle btn-ghost"
                onClick={() => setSidebarOpen(false)}
              >
                ✕
              </button>
            </div>
            {loading && (
              <div className="flex items-center justify-center h-screen">
                <div className="loading loading-spinner loading-lg"></div>
              </div>
            )}
            {!loading && (
              <div className="flex flex-col items-center py-16">
                
                <div className="avatar">
                  <div className="flex justify-center">
                    <div
                      className={`avatar placeholder bg-blue-500 text-white rounded-full w-24 h-24 flex items-center justify-center shadow-md border-4 border-white`}
                    >
                      <span className="text-4xl font-bold">
                        {products[0]?.name.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  </div>
                </div>
                 <h2 className="text-xl font-bold mt-4">{products[0]?.name}</h2>
      
                <p className="text-sm text-gray-500">
                  {products[0]?.tutor_subject || "No subject specified"}
                </p>
                <div className="mt-2 flex justify-center items-center">
                  <span className="text-sm mr-2">{products[0]?.syllabus}</span>
                  <div className="badge badge-primary">
                    ID: {products[0]?.id}
                  </div>
                </div>
              </div>
            )}
            {!loading && (
              <ul className="menu p-0">
                <li className="menu-title">My Learning</li>

                 <li>
                  <a
                    className={activeTab === "dashboard" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("dashboard");
                      if (window.innerWidth < 1024) setSidebarOpen(false);
                    }}
                  >
                    <i className="fas fa-book mr-3"></i> Dashboard
                  </a>
                </li>
                <li>
                  <a
                    className={activeTab === "courses" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("courses");
                      if (window.innerWidth < 1024) setSidebarOpen(false);
                    }}
                  >
                    <i className="fas fa-book mr-3"></i> My Courses
                  </a>
                </li>
                <li>
                  <a
                    className={activeTab === "classrooms" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("classrooms");
                      if (window.innerWidth < 1024) setSidebarOpen(false);
                    }}
                  >
                    <i className="fas fa-calendar-alt mr-3"></i> My Sessions
                  </a>
                </li>
                <li>
                  <a
                    className={activeTab === "messages" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("messages");
                      if (window.innerWidth < 1024) setSidebarOpen(false);
                    }}
                  >
                    <i className="fas fa-envelope mr-3"></i> Inbox
                  </a>
                </li>
                <li>
                  <a
                    className={activeTab === "documents" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("documents");
                      if (window.innerWidth < 1024) setSidebarOpen(false);
                    }}
                  >
                    <i className="fas fa-file-alt mr-3"></i> Documents
                  </a>
                </li>
              </ul>
            )}
            {!loading ? (
              <UpcomingClassesSidebarTutor tutorId={products[0]?.id} />
            ) : null}
            {/* <div className="mt-8">
              <h3 className="text-lg font-semibold mb-3">Upcoming Classes</h3>
              <div className="bg-primary/10 p-3 rounded-lg mb-3">
                <p className="font-medium">Calculus 101</p>
                <p className="text-sm">Today, 2:00 PM</p>
              </div>
              <div className="bg-primary/10 p-3 rounded-lg">
                <p className="font-medium">Physics Advanced</p>
                <p className="text-sm">Tomorrow, 11:00 AM</p>
              </div>
            </div> */}
          </div>
        </div>

        {/* Overlay for mobile when sidebar is open */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          ></div>
        )}

        {/* Content Area */}
       
        <div className="flex-1 p-6 lg:p-16 w-full">
           <h1 className="text-6xl text-center">👩‍🏫</h1>
          {activeTab === "courses" && <EnrollmentsListTutor id={products[0]?.id} />}
          {!loading && activeTab === "dashboard" && (
            <EnrollmentsListTutor id={products[0]?.id} />
          )}

          {activeTab === "classrooms" && <SessionsList2Tutor id={products[0]?.id} />}
          {activeTab === "messages" && <GeneralMessages flag={false}  />}

          {activeTab === "documents" && <DisplayDocuments flag={false} />}
        </div>
      </div>
    </div>
    </>
  );
};

export default SideBarMenuTutor;
